import { IBaseCard } from "./base-card.interface";
import { ComputedCard, CosmosEntity } from "./card-basics.interface";

export interface IFirmTaxprepT1Card extends CosmosEntity, ComputedCard {
    id: string;
    cardId: string;
    dashboardId: string;
    return: {
        id: string;
        type: string; // "Taxpayer" | "Spouse" | "Dependant"
        statusId: string;
        statusDate: number;
        statusUserId: string;
    };
    filePath: string | null;
    documentId: string;
    categoryId: string | null;
    officeId: string | null;
    group1Id: string | null;
    group2Id: string | null;
    roleUserMapping: Array<{
        roleId: string;
        userId: string; // Can be empty string or UUID
    }>;
    isSplit: boolean | null; // Can be null
    isVIP: boolean;
    inAlertAt: number | null;
    inDangerAt: number | null;
    name: string;
    contactInformation: {
        firstName: string;
        lastName: string;
        phone: string;
        email: string;
        cellPhone: string;
        iFirmContactId: string;
    };
    lastYearDocumentsReceivedDate: number | null;
    documentsReceivedDate: number | null;
    lastYearCompletedDate: number | null;
    deadLine: number | null;
    quiet: number | null;
    paymentDate: number | null;
    taxYearEndDate: number | null;
    groupName: string | null;
    note: string | null;
    temporaryNote: string | null;
    clientCodes: {
        clientCodePIN?: string | null; // Optional - not always present
        clientCodeId?: string | null; // Optional - not always present
        clientCodeiFirm: string | null; // Always present
    };
    statusesHistory: Array<{
        statusId: string;
        statusDate: number;
        userId: string | null; // Can be null
    }>;
    lastYearStatusesHistory: Array<{
        statusId: string;
        statusDate: number;
        userId: string | null; // Can be null
    }>;
    efileStatuses: {
        fedEfileStatus: number;
        provEfileStatus: number;
        t1135EfileStatus: number;
        rC4649EfileStatus: number;
        aT1EfileStatus: number;
    };
    members: Array<{
        cardId: string;
    }>;
    tags: string[];
    originalId: string | null;
    applyStatusToAll: boolean | null;
    applyAssigneesToAll: boolean | null;
    dateNeeded: number | null;
    deliveryMethod: number | null; // Number, not string
}

export function isIFirmTaxprepT1Card(card: IBaseCard): card is IFirmTaxprepT1Card {
    return "documentId" in card && card.documentId !== null && card.documentId !== undefined;
}
